import {
  useMetricsStats,
  useMetricsTrends,
  useMetricsDistribution,
  useMetricsPatterns,
} from "../../../../../shared/hooks";
import type {
  MetricsStatsParams,
  MetricsTrendsParams,
  MetricsFilters,
  MetricsPatternsParams,
} from "../../../../../shared/api/types";

export const useStrainActivityStats = (params?: MetricsStatsParams) => {
  return useMetricsStats({
    ...params,
    metrics: params?.metrics || ["day_strain", "active_time", "calories_burn"],
  });
};

export const useStrainActivityTrends = (params?: MetricsTrendsParams) => {
  return useMetricsTrends({
    ...params,
    metrics: params?.metrics || ["day_strain", "cardio_load", "heart_rate", "calories_burn"],
    granularity: params?.granularity || "daily",
  });
};

export const useHeartRateZonesDistribution = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: "heart_rate_zones",
  });
};

export const useStrainPatterns = (params: MetricsPatternsParams) => {
  return useMetricsPatterns({
    ...params,
    metric: "strain_patterns",
  });
};

export const useRecoveryPatterns = (params: MetricsPatternsParams) => {
  return useMetricsPatterns({
    ...params,
    metric: "recovery_patterns",
  });
};
